import { useEffect } from 'react';
import { mount2022Runtime } from './runtime';
import styleUrl from '../../assets/2022/style/style.css?url';
import swiperStyleUrl from '../../assets/2022/style/swiper-bundle.min.css?url';
import swiperScriptUrl from '../../assets/2022/js/swiper.js?url';

type Lang = 'en' | 'zh';

type Use2022PageOptions = {
  cate: string;
  lang: Lang;
  title: string;
};

export const use2022Page = ({ cate, lang, title }: Use2022PageOptions) => {
  useEffect(() => {
    // Use clean routes without .php
    const cleanPath = lang === 'en' ? `/2022/${cate}` : `/2022/zh/${cate}`;
    if (window.location.pathname !== cleanPath) {
      window.history.replaceState({}, '', cleanPath + window.location.search + window.location.hash);
    }

    document.body.className = cate === 'index' ? 'Home' : '';
    document.body.setAttribute('cate', cate);
    document.body.setAttribute('lang', lang);
    document.title = title;

    const styleId = 'slpa2022-site-style';
    const swiperStyleId = 'slpa2022-swiper-style';

    let styleEl = document.getElementById(styleId) as HTMLLinkElement | null;
    if (!styleEl) {
      styleEl = document.createElement('link');
      styleEl.id = styleId;
      styleEl.rel = 'stylesheet';
      styleEl.href = styleUrl;
      document.head.appendChild(styleEl);
    }

    let swiperEl = document.getElementById(swiperStyleId) as HTMLLinkElement | null;
    if (!swiperEl) {
      swiperEl = document.createElement('link');
      swiperEl.id = swiperStyleId;
      swiperEl.rel = 'stylesheet';
      swiperEl.href = swiperStyleUrl;
      document.head.appendChild(swiperEl);
    }

    const swiperScriptId = 'slpa2022-swiper-script';
    let cleanupRuntime: (() => void) | null = null;
    let cancelled = false;

    const mountWithRuntime = () => {
      if (cancelled) return;
      cleanupRuntime = mount2022Runtime();
    };

    const existingScript = document.getElementById(swiperScriptId) as HTMLScriptElement | null;
    if (existingScript) {
      if ((window as Window & { Swiper?: unknown }).Swiper) {
        mountWithRuntime();
      } else {
        const onLoad = () => mountWithRuntime();
        existingScript.addEventListener('load', onLoad, { once: true });
      }
    } else {
      const scriptEl = document.createElement('script');
      scriptEl.id = swiperScriptId;
      scriptEl.src = swiperScriptUrl;
      scriptEl.async = true;
      scriptEl.addEventListener('load', () => mountWithRuntime(), { once: true });
      document.body.appendChild(scriptEl);
    }

    return () => {
      cancelled = true;
      cleanupRuntime?.();
      styleEl?.remove();
      swiperEl?.remove();
    };
  }, [cate, lang, title]);
};

export const navEn = `
<header>
  <div class="Header_Logo">
    <h1><a href="/2022"><img src="/2022/images/home-logo.png" alt="logo"/></a></h1>
  </div>
  <div id="navmenu">
    <div id="menu-trigger"><div class="menu-icon"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div></div></div>
    <div id="navmenuul">
      <li><a href="/2022/awards.php">AWARDS CATEGORIES</a></li>
      <li><a href="/2022/judges.php">JUDGES</a></li>
      <li><a href="/2022/winners.php">WINNERS</a></li>
      <li><a href="/2022/judges_criteria.php">JUDGES CRITERIA</a></li>
      <li><a href="/2022/related_events.php">RELATED EVENTS</a></li>
      <li><a href="/2022/highlights.php">HIGHLIGHTS</a></li>
      <li><a id="Lang">中文</a></li>
    </div>
  </div>
</header>
`;

export const navZh = `
<header>
  <div class="Header_Logo">
    <h1><a href="/2022/zh"><img src="/2022/images/home-logo.png" alt="logo"/></a></h1>
  </div>
  <div id="navmenu">
    <div id="menu-trigger"><div class="menu-icon"><div class="bar1"></div><div class="bar2"></div><div class="bar3"></div></div></div>
    <div id="navmenuul">
      <li><a href="/2022/zh/awards.php">得獎類別</a></li>
      <li><a href="/2022/zh/judges.php">評審</a></li>
      <li><a href="/2022/zh/winners.php">得獎名單</a></li>
      <li><a href="/2022/zh/judges_criteria.php">評審準則</a></li>
      <li><a href="/2022/zh/related_events.php">相關活動</a></li>
      <li><a href="/2022/zh/highlights.php">花絮</a></li>
      <li><a id="Lang">English</a></li>
    </div>
  </div>
</header>
`;

export const introWrap = (nav: string) => `
<div class="Intro">
  <div class="background_test"><img src="/2022/images/KVbackgound-01.jpg" alt="bg"/></div>
  <div class="background_wrapper">
    ${nav}
    <section class="Hero">
      <div class="Slogan">BUILDING A SUSTAINABLE<br>SMART LIVING</div>
      <div class="Ball"><div class="BallWrap"><img src="/2022/images/waveball.gif" alt="KV-glass-ball-outside"/><div class="ClearBall"><img src="/2022/images/Mainbubble.png" alt="KV-glass"/></div></div></div>
      <div class="LeftBall"><img src="/2022/images/Leftbubble.png" alt="Leftbubble"/><svg></svg></div>
      <div class="RightBall"><img src="/2022/images/Rightbubble.png" alt="Rightbubble"/></div>
    </section>
  </div>
</div>
`;

export const footerEn = `
<div class="footer_container">
  <div class="footer_container_left">
    <div class="footer_smartliving_logo"><img src="/2022/images/logo-2022.png" alt=""></div>
    <div class="footer_contactUs">
      <div class="footer_contactUs_title">Contact Us</div>
      <div class="footer_contactUs_icon"><a href="tel:+852-28802978"><img src="/2022/images/phone.png" alt=""></a> <a href="mailto:smartcityawards@etnet.com.hk"><img src="/2022/images/email.png" alt=""></a></div>
    </div>
    <div class="footer_shareTo">
      <div class="footer_shareTo_title">Share to</div>
      <div class="footer_shareTo_icon"><a href="https://www.facebook.com/sharer.php?u=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2022" target="_blank" rel="noreferrer"><img src="/2022/images/fb.png" alt=""></a> <a href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2022" target="_blank" rel="noreferrer"><img src="/2022/images/linkedin.png" alt=""></a> <a href="https://wa.me/?text=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2022" target="_blank" rel="noreferrer"><img src="/2022/images/whatsapp.png" alt=""></a></div>
    </div>
    <div class="disclaimer">© 2023 ET Net Limited. All rights reserved.</div>
  </div>
  <div class="footer_container_right">
    <div class="footer_organiser">
      <div class="footer_organiser_title">Organiser</div>
      <div class="footer_organiser_logo"><a href="http://www.etnet.com.hk" target="_blank" rel="noreferrer"><img src="/2022/images/etnet.svg" alt=""></a></div>
    </div>
    <div class="footer_co_organiser">
      <div class="footer_co_organiser_title">Co-organiser</div>
      <div class="footer_co_organiser_logo"><a href="http://www.cyberport.hk/en" target="_blank" rel="noreferrer"><img src="/2022/images/cyberport.png" alt=""></a></div>
    </div>
    <div class="footer_strategic_partners">
      <div class="footer_strategic_partners_title">Strategic Partners</div>
      <div class="footer_strategic_partners_logo"><a href="https://home.kpmg/cn/en/home.html" target="_blank" rel="noreferrer"><img src="/2022/images/kpmg.png" alt=""></a><a href="https://smartcity.org.hk/index.php/en/" target="_blank" rel="noreferrer"><img src="/2022/images/scc.png" alt=""></a></div>
    </div>
    <div class="footer_sponsor">
      <div class="footer_sponsor_title">Sponsor</div>
      <div class="footer_sponsor_logo"><a href="https://www.deloitte.com/global/en.html" target="_blank" rel="noreferrer"><img src="/2022/images/Deloitte.png" alt=""></a></div>
    </div>
    <div class="footer_supporting_organiser">
      <div class="footer_supporting_organiser_title">Supporting Organisations</div>
      <div class="footer_supporting_organiser_logo"><a href="https://www.ent-fund.org/en/" target="_blank" rel="noreferrer"><img src="/2022/images/AEF.png" alt=""></a><a href="https://www.industryhk.org/en/" target="_blank" rel="noreferrer"><img src="/2022/images/FHKI.png" alt=""></a><a href="https://ghkmbayarea.org/" target="_blank" rel="noreferrer"><img src="/2022/images/gba.png" alt=""></a><a href="https://www.hkna.org/" target="_blank" rel="noreferrer"><img src="/2022/images/HKNA.png" alt=""></a><a href="https://www.hkpc.org/en" target="_blank" rel="noreferrer"><img src="/2022/images/HKPC.png" alt=""></a><a href="http://www.hkrtia.org/" target="_blank" rel="noreferrer"><img src="/2022/images/RTIA.png" alt=""></a><a href="https://www.hkstp.org/" target="_blank" rel="noreferrer"><img src="/2022/images/HKSTP2.png" alt=""></a><a href="https://cftasia.org/" target="_blank" rel="noreferrer"><img src="/2022/images/IFTA.png" alt=""></a><a href="https://www.lscm.hk/eng/" target="_blank" rel="noreferrer"><img src="/2022/images/LSCM.jpg" alt=""></a><a href="https://www.opotechnology.com/" target="_blank" rel="noreferrer"><img src="/2022/images/OPo.png" alt=""></a><a href="https://www.startmeup.hk/" target="_blank" rel="noreferrer"><img src="/2022/images/SMUHK.png" alt=""></a><a href="https://hktin.org/" target="_blank" rel="noreferrer"><img src="/2022/images/TIN.png" alt=""></a><a href="https://www.acmcp.org/" target="_blank" rel="noreferrer"><img src="/2022/images/ACMCP.png" alt=""></a>
        <div class="footer_supporting_organiser_remarks">Listed in alphabetical order</div>
      </div>
    </div>
  </div>
</div>
`;

export const footerZh = `
<div class="footer_container">
  <div class="footer_container_left">
    <div class="footer_smartliving_logo"><img src="/2022/images/logo-2022.png" alt=""></div>
    <div class="footer_contactUs">
      <div class="footer_contactUs_title">活動查詢</div>
      <div class="footer_contactUs_icon"><a href="tel:+852-28802978"><img src="/2022/images/phone.png" alt=""></a> <a href="mailto:smartcityawards@etnet.com.hk"><img src="/2022/images/email.png" alt=""></a></div>
    </div>
    <div class="footer_shareTo">
      <div class="footer_shareTo_title">分享到</div>
      <div class="footer_shareTo_icon"><a href="https://www.facebook.com/sharer.php?u=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2022%2Fzh" target="_blank" rel="noreferrer"><img src="/2022/images/fb.png" alt=""></a> <a href="https://www.linkedin.com/sharing/share-offsite/?url=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2022%2Fzh" target="_blank" rel="noreferrer"><img src="/2022/images/linkedin.png" alt=""></a> <a href="https://wa.me/?text=https%3A%2F%2Fsmartcityslpa.etnet.com.hk%2F2022%2Fzh" target="_blank" rel="noreferrer"><img src="/2022/images/whatsapp.png" alt=""></a></div>
    </div>
    <div class="disclaimer">© 2023 經濟通有限公司 版權所有 不得轉載</div>
  </div>
  <div class="footer_container_right">
    <div class="footer_organiser">
      <div class="footer_organiser_title">主辦機構</div>
      <div class="footer_organiser_logo"><a href="http://www.etnet.com.hk" target="_blank" rel="noreferrer"><img src="/2022/images/etnet.svg" alt=""></a></div>
    </div>
    <div class="footer_co_organiser">
      <div class="footer_co_organiser_title">協辦機構</div>
      <div class="footer_co_organiser_logo"><a href="http://www.cyberport.hk/en" target="_blank" rel="noreferrer"><img src="/2022/images/cyberport.png" alt=""></a></div>
    </div>
    <div class="footer_strategic_partners">
      <div class="footer_strategic_partners_title">策略夥伴</div>
      <div class="footer_strategic_partners_logo"><a href="https://home.kpmg/cn/en/home.html" target="_blank" rel="noreferrer"><img src="/2022/images/kpmg.png" alt=""></a><a href="https://smartcity.org.hk/index.php/en/" target="_blank" rel="noreferrer"><img src="/2022/images/scc.png" alt=""></a></div>
    </div>
    <div class="footer_sponsor">
      <div class="footer_sponsor_title">贊助機構</div>
      <div class="footer_sponsor_logo"><a href="https://www.deloitte.com/global/en.html" target="_blank" rel="noreferrer"><img src="/2022/images/Deloitte.png" alt=""></a></div>
    </div>
    <div class="footer_supporting_organiser">
      <div class="footer_supporting_organiser_title">支持機構</div>
      <div class="footer_supporting_organiser_logo"><a href="https://www.ent-fund.org/en/" target="_blank" rel="noreferrer"><img src="/2022/images/AEF.png" alt=""></a><a href="https://www.industryhk.org/en/" target="_blank" rel="noreferrer"><img src="/2022/images/FHKI.png" alt=""></a><a href="https://ghkmbayarea.org/" target="_blank" rel="noreferrer"><img src="/2022/images/gba.png" alt=""></a><a href="https://www.hkna.org/" target="_blank" rel="noreferrer"><img src="/2022/images/HKNA.png" alt=""></a><a href="https://www.hkpc.org/en" target="_blank" rel="noreferrer"><img src="/2022/images/HKPC.png" alt=""></a><a href="http://www.hkrtia.org/" target="_blank" rel="noreferrer"><img src="/2022/images/RTIA.png" alt=""></a><a href="https://www.hkstp.org/" target="_blank" rel="noreferrer"><img src="/2022/images/HKSTP2.png" alt=""></a><a href="https://cftasia.org/" target="_blank" rel="noreferrer"><img src="/2022/images/IFTA.png" alt=""></a><a href="https://www.lscm.hk/eng/" target="_blank" rel="noreferrer"><img src="/2022/images/LSCM.jpg" alt=""></a><a href="https://www.opotechnology.com/" target="_blank" rel="noreferrer"><img src="/2022/images/OPo.png" alt=""></a><a href="https://www.startmeup.hk/" target="_blank" rel="noreferrer"><img src="/2022/images/SMUHK.png" alt=""></a><a href="https://hktin.org/" target="_blank" rel="noreferrer"><img src="/2022/images/TIN.png" alt=""></a><a href="https://www.acmcp.org/" target="_blank" rel="noreferrer"><img src="/2022/images/ACMCP.png" alt=""></a>
        <div class="footer_supporting_organiser_remarks">排名按字母順序排列</div>
      </div>
    </div>
  </div>
</div>
`;

